<template>
  <div class="empty-container">
    <section class="empty-image">
      <img
        src="https://static.soyoung.com/sy-pre/empty-icon-1682647800733.svg"
        alt=""
      />
    </section>
    <p class="description">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "empty",
  props: {
    text: {
      type: String,
      default: "暂无数据！",
    },
  },
};
</script>

<style lang="less" scoped>
.empty-container {
  .empty-image {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .description {
    font-size: 14px;
    line-height: 1.5;
    text-align: center;
    padding-top: 20px;
    color: #e6e6e6;
  }
}
</style>
